import { useQuery } from '@tanstack/react-query';
import { get } from 'lib/api';

const getCurrentUser = async () => {    
  try {
    const req = await get('auth/user');
    return req.data.payload;
  } catch (error) {
    throw error;
  }
};

export function useLoggedInUser() {
  const userQuery = useQuery({
    queryKey: ['currentUser'],
    queryFn: () => {
      return getCurrentUser();
    },
    staleTime: 1000 * 60 * 5 // 5 min
  });

  return userQuery;
}
